import { Instagram, Linkedin } from "lucide-react";
import { BOOK } from "../lib/content";

export const Footer = () => (
  <footer className="border-t border-white/5 py-14" data-testid="site-footer">
    <div className="max-w-7xl mx-auto px-4 sm:px-8 lg:px-16 flex flex-col md:flex-row items-center justify-between gap-8">
      <div className="text-center md:text-left">
        <span className="font-display font-medium text-xs tracking-[0.3em] text-gold block uppercase">Edgar Merino Vidangossy</span>
        <span className="font-serif-book italic text-sm text-[#6E6C67]">Juega Tu Partido · {BOOK.isbn}</span>
      </div>
      <div className="flex items-center gap-6">
        <a href="https://www.instagram.com/edgarmerino19" target="_blank" rel="noopener noreferrer" aria-label="Instagram" data-testid="footer-social-instagram" className="text-[#A19F9A] hover:text-[#C5A059] transition-colors duration-300">
          <Instagram size={17} />
        </a>
        <a href="https://www.linkedin.com/in/edgarmerino19" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn" data-testid="footer-social-linkedin" className="text-[#A19F9A] hover:text-[#C5A059] transition-colors duration-300">
          <Linkedin size={17} />
        </a>
      </div>
      <span className="text-xs text-[#6E6C67]">© 2026 Edgar Merino Vidangossy. Todos los derechos reservados.</span>
    </div>
  </footer>
);
